import { ReactComponent as FlagIcon } from "./svg/ua-flag.svg";
import "../flag-icon.scss";

export const UAFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
